import React, { useState } from 'react';
import { Plus, X, User, Calendar, FileText, AlertCircle } from 'lucide-react';
import './CreateParticipantInline.css';
const CreateParticipantInline = ({ onParticipantCreated, onCancel }) => {
  const [formData, setFormData] = useState({
    type: 'Child',
    nome: '',
    dataNascimento: '',
    cartaoCidadao: '',
    estabelecimentoEnsino: '',
    validoAte: '',
    nif: '',
    alergias: '',
    alimentosProibidos: '',
    medicacaoFrequente: '',
    necessidadesEducativas: '',
    outrosAspectos: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.nome || !formData.dataNascimento) {
      setError('Nome e data de nascimento são obrigatórios');
      return;
    }

    setLoading(true);

    try {
      const participantData = {
        type: formData.type === 'Child' ? 0 : 1,
        nome: formData.nome,
        dataNascimento: formData.dataNascimento,
        cartaoCidadao: formData.cartaoCidadao || null,
        estabelecimentoEnsino: formData.estabelecimentoEnsino || null,
        validoAte: formData.validoAte || null,
        nif: formData.nif || null,
        alergias: formData.alergias || null,
        alimentosProibidos: formData.alimentosProibidos || null,
        medicacaoFrequente: formData.medicacaoFrequente || null,
        necessidadesEducativas: formData.necessidadesEducativas || null,
        outrosAspectos: formData.outrosAspectos || null
      };

      console.log(JSON.stringify(participantData))

      const response = await fetch('https://www.barcodepapel.pt:5017/api/participants', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(participantData)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar participante');
      }

      const newParticipant = await response.json();
      onParticipantCreated(newParticipant);

    } catch (err) {
      setError(err.message || 'Erro ao criar participante');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-participant-inline">
      <div className="inline-header">
        <h4>
          <User size={20} />
          Criar Novo Participante
        </h4>
        <button type="button" onClick={onCancel} className="close-inline-btn">
          <X size={20} />
        </button>
      </div>

      {error && (
        <div className="inline-error">
          <AlertCircle size={16} />
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="inline-form">
        <div className="form-row">
          <label>
            <span className="label-text">Tipo *</span>
            <select
              value={formData.type}
              onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              required
            >
              <option value="Child">Criança</option>
              <option value="Adult">Adulto</option>
            </select>
          </label>
        </div>

        <div className="form-row-2">
          <label>
            <span className="label-text">Nome Completo *</span>
            <input
              type="text"
              value={formData.nome}
              onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
              placeholder="Nome completo"
              required
            />
          </label>

          <label>
            <span className="label-text">Data de Nascimento *</span>
            <input
              type="date"
              value={formData.dataNascimento}
              onChange={(e) => setFormData({ ...formData, dataNascimento: e.target.value })}
              required
            />
          </label>
        </div>

        <div className="form-row-2">
          <label>
            <span className="label-text">Cartão Cidadão</span>
            <input
              type="text"
              value={formData.cartaoCidadao}
              onChange={(e) => setFormData({ ...formData, cartaoCidadao: e.target.value })}
              placeholder="Número do CC"
            />
          </label>

          <label>
            <span className="label-text">Válido Até</span>
            <input
              type="date"
              value={formData.validoAte}
              onChange={(e) => setFormData({ ...formData, validoAte: e.target.value })}
            />
          </label>
        </div>

        <div className="form-row-2">
          <label>
            <span className="label-text">NIF</span>
            <input
              type="text"
              value={formData.nif}
              onChange={(e) => setFormData({ ...formData, nif: e.target.value })}
              placeholder="Número fiscal"
            />
          </label>

          <label>
            <span className="label-text">Estabelecimento de Ensino</span>
            <input
              type="text"
              value={formData.estabelecimentoEnsino}
              onChange={(e) => setFormData({ ...formData, estabelecimentoEnsino: e.target.value })}
              placeholder="Nome da escola"
            />
          </label>
        </div>

        <details className="medical-section">
          <summary>
            <FileText size={16} />
            Informações Médicas (opcional)
          </summary>

          <div className="medical-fields">
            <label>
              <span className="label-text">Alergias</span>
              <textarea
                value={formData.alergias}
                onChange={(e) => setFormData({ ...formData, alergias: e.target.value })}
                placeholder="Descreva alergias conhecidas"
                rows="2"
              />
            </label>

            <label>
              <span className="label-text">Alimentos Proibidos</span>
              <textarea
                value={formData.alimentosProibidos}
                onChange={(e) => setFormData({ ...formData, alimentosProibidos: e.target.value })}
                placeholder="Liste alimentos a evitar"
                rows="2"
              />
            </label>

            <label>
              <span className="label-text">Medicação Frequente</span>
              <textarea
                value={formData.medicacaoFrequente}
                onChange={(e) => setFormData({ ...formData, medicacaoFrequente: e.target.value })}
                placeholder="Medicação regular"
                rows="2"
              />
            </label>

            <label>
              <span className="label-text">Necessidades Educativas Especiais</span>
              <textarea
                value={formData.necessidadesEducativas}
                onChange={(e) => setFormData({ ...formData, necessidadesEducativas: e.target.value })}
                placeholder="Necessidades específicas"
                rows="2"
              />
            </label>

            <label>
              <span className="label-text">Outros Aspectos</span>
              <textarea
                value={formData.outrosAspectos}
                onChange={(e) => setFormData({ ...formData, outrosAspectos: e.target.value })}
                placeholder="Outras informações relevantes"
                rows="2"
              />
            </label>
          </div>
        </details>

        <div className="inline-actions">
          <button type="button" onClick={onCancel} className="cancel-inline-btn" disabled={loading}>
            Cancelar
          </button>
          <button type="submit" className="submit-inline-btn" disabled={loading}>
            {loading ? 'A criar...' : 'Criar Participante'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateParticipantInline;